export const types = {
  CANCEL_EDIT_INTERROGATION_SETUP:
    'partLibrary/viewer/geometricInterrogation/CANCEL_EDIT_INTERROGATION_SETUP',
  CLEAR: 'partLibrary/viewer/geometricInterrogation/CLEAR',
  EDIT_INTERROGATION_SETUP:
    'partLibrary/viewer/geometricInterrogation/EDIT_INTERROGATION_SETUP',
  RECEIVE_QUERY: 'partLibrary/viewer/geometricInterrogation/RECEIVE_QUERY',
  RECEIVE_RESULT_FOR_DEFAULT:
    'partLibrary/viewer/geometricInterrogation/RECEIVE_RESULT_FOR_DEFAULT',
  RECEIVE_SEARCH_RESULTS:
    'partLibrary/viewer/geometricInterrogation/RECEIVE_SEARCH_RESULTS',
  SET_WITH_INTERROGATION_FILE:
    'partLibrary/viewer/geometricInterrogation/SET_WITH_INTERROGATION_FILE',
  SUBMIT: 'partLibrary/viewer/geometricInterrogation/SUBMIT',
};

export const geometricInterrogation = {
  cancelEditInterrogationSetup: () => ({
    type: types.CANCEL_EDIT_INTERROGATION_SETUP,
  }),
  clear: () => ({
    type: types.CLEAR,
  }),
  editInterrogationSetup: () => ({
    type: types.EDIT_INTERROGATION_SETUP,
  }),
  receiveQuery: ({
    forceInfo,
    material,
    task,
    shouldInit,
    useSelectedTask,
  }) => ({
    type: types.RECEIVE_QUERY,
    payload: { forceInfo, material, task, shouldInit, useSelectedTask },
  }),
  receiveResultForDefault: ({ result }) => ({
    type: types.RECEIVE_RESULT_FOR_DEFAULT,
    payload: { result },
  }),
  receiveSearchResults: ({ results }) => ({
    type: types.RECEIVE_SEARCH_RESULTS,
    payload: { results },
  }),
  setWithInterrogationFile: ({
    partFileUuid,
    partInterrogationFile,
    showAdditionalKeysExplicit,
  }) => ({
    type: types.SET_WITH_INTERROGATION_FILE,
    payload: {
      partFileUuid,
      partInterrogationFile,
      showAdditionalKeysExplicit,
    },
  }),
  submit: ({ result }) => ({
    type: types.SUBMIT,
    payload: { result },
  }),
};
